import { validateCurrency } from "../../../services/validate";
import {
  BaSeButton,
  BaSeGrid,
  BaSeGridItem,
  BaSeHeading5,
  BaSeHeading6,
  BaSeInput,
  BaSeOptionPicker,
} from "@base/react";
import { toast } from "react-toastify";
import ToastContent from "../../../components/toastContent";
import React, { useCallback, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  convertObjectValuesToFloat,
  formatCurrency,
  formatFloat,
  principal,
} from "../../../services/utils";
import { useParams } from "react-router-dom";
import Loading from "../../../components/loading";
import TipBlock from "../../../components/tip-block";
import logoFampe from "../../../assets/images/fampe.png";
import FampeInputRange from "../../../components/fampe-input-range";
import ApiCompaniesSizes from "../../../services/companiesSizes";
import RedStatus from "../../../assets/images/fampe-red-status.png";
import GreenStatus from "../../../assets/images/fampe-green-status.png";
import YellowStatus from "../../../assets/images/fampe-yellow-status.png";
import iconError from "../../../assets/images/icons/exclamation-octagon.png";
import ApiPlannings from "../../../services/planning";
const apiCompaniesSizes = ApiCompaniesSizes();
const apiPlannings = ApiPlannings();

const companySizes = [
  {
    id: 99,
    label: "Microempreendedor Individual",
    sigla: "MEI",
    ceiling: 100000,
  },
  { id: 2, label: "Microempresa", sigla: "ME", ceiling: 400000 },
  { id: 3, label: "Empresa de pequeno porte", sigla: "EPP", ceiling: 700000 },
];
const Guarantees = ({ dataPlanning, sendForm, backStep, companies }) => {
  const { idEdit } = useParams();
  const id = idEdit;
  const [fampeGuarantee, setFampeGuarantee] = useState(0);
  const [necessaryComplement, setNecessaryComplement] = useState(0);
  const [limitStatus, setLimitStatus] = useState(80);
  const [form, setForm] = useState({
    financingValue: formatCurrency(dataPlanning?.fampe?.financing_value) || 0,
    guaranteesValue: formatCurrency(dataPlanning?.fampe?.guarantees_value) || 0,
    company_size: companySizes[1].id,
    percent: limitStatus / 100,
  });
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([companySizes[0].id]);
  const getCeiling = useCallback(() => {
    const currentCompanySize = companySizes.find(
      (item) => item.id === selected[0]
    );
    return currentCompanySize.ceiling;
  }, [selected]);

  const getCompaniesSizes = () => {
    setLoading(true);
    apiCompaniesSizes
      .getCompaniesSizes(principal(companies))
      .then((response) => {
        const { data } = response;

        const selectedCompanySize = companySizes.find(
          (item) => item.id === data.codPorte
        );
        setSelected([selectedCompanySize.id]);
      })
      .catch((err) => console.warn(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getCompaniesSizes();
    // eslint-disable-next-line
  }, []);

  const fetchPlanning = async (
    id,
    setForm,
    setSelected,
    setLimitStatus,
    setFampeGuarantee,
    setNecessaryComplement
  ) => {
    try {
      setLoading(true);
      const response = await apiPlannings.getPlanning(id);
      const updatedData = response.data.fampe;

      if (updatedData) {
        const selectedCompany = companySizes.find(
          (c) => c.sigla === updatedData.company_size
        );

        setForm({
          financingValue: formatCurrency(updatedData.financing_value),
          guaranteesValue: formatCurrency(updatedData.guarantees_value),
          company_size: selectedCompany?.id || companySizes[1].id,
          percent: updatedData.percent,
        });

        if (selectedCompany) setSelected([selectedCompany.id]);
        setLimitStatus(updatedData.percent * 100);
        setFampeGuarantee(updatedData.fampe_guarantee);
        setNecessaryComplement(updatedData.necessary_complement);
      }
    } catch (err) {
      console.error("Erro ao buscar planejamento:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPlanning(
        id,
        setForm,
        setSelected,
        setLimitStatus,
        setFampeGuarantee,
        setNecessaryComplement
      );
    }
  }, [id]);

  const handleSubmitForm = async () => {
    try {
      const selectedCompany = companySizes.find((c) => c.id === selected[0]);
      const { financingValue, guaranteesValue } = convertObjectValuesToFloat({
        financingValue: form.financingValue,
        guaranteesValue: form.guaranteesValue,
      });

      const payloadSimulateFAMPE = {
        company_size: selectedCompany.sigla,
        financing_value: financingValue,
        guarantees_value: guaranteesValue,
        percent: limitStatus / 100,
      };

      const response = await apiPlannings.simulateFampe(payloadSimulateFAMPE);

      if (response?.data) {
        const { fampe_guarantee, necessary_complement, percent_used } =
          response.data;

        setLimitStatus(percent_used * 100);
        setFampeGuarantee(fampe_guarantee);
        setNecessaryComplement(necessary_complement);

        const payloadToSave = {
          cnpj: dataPlanning?.cnpj || "",
          company_size: selectedCompany.sigla,
          percent: percent_used,
          financing_value: financingValue,
          guarantees_value: guaranteesValue,
          fampe_guarantee: fampe_guarantee,
          necessary_complement: necessary_complement,
        };

        await sendForm(payloadToSave, false, true);
      }
    } catch (error) {
      console.error("Erro ao simular e salvar FAMPE:", error);
      toast.error(
        <ToastContent
          title="Falha!"
          description="Ocorreu um erro ao calcular as garantias. Tente novamente."
        />,
        {
          icon: () => <img src={iconError} alt="icon" />,
        }
      );
    }
  };

  return loading ? (
    <Loading />
  ) : (
    <div className="step guarantees">
      <BaSeHeading5
        color="#005EB8"
        fontFamily="Alegreya Sans"
        isBold
        className="mt-0"
      >
        FAMPE
      </BaSeHeading5>
      <BaSeGrid>
        <BaSeGridItem
          desktop={{
            size: 9,
            startAt: undefined,
          }}
          desktopLarge={{
            size: 8,
            startAt: undefined,
          }}
        >
          <p>
            O FAMPE é o fundo de aval do Sebrae que existe para te ajudar a
            completar o valor exigido pelo banco como garantia para o
            financiamento pretendido.
          </p>
          <p>
            Verifique os Limites de Garantia do FAMPE por Porte e Modalidade e
            conheça mais sobre o FAMPE no Portal Sebrae.
          </p>

          <Formik initialValues={form} onSubmit={() => {}}>
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <div className="wrapper-select">
                  <BaSeOptionPicker
                    label="Porte da empresa"
                    values={companySizes}
                    enableSelectAll={false}
                    menuAlwaysIsOpen={false}
                    withFilterText={false}
                    emptyValueLabel="Selecione"
                    maxOptionsSelected={1}
                    initialSelectedValuesId={selected}
                    onChange={(values) => {
                      setSelected(values.map((val) => val.id));
                    }}
                  />
                </div>
                <div className="group-input">
                  <BaSeGrid>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <BaSeInput
                        color="default"
                        inputMode="tel"
                        typeInput="tel"
                        inputStatus={
                          validateCurrency(form.financingValue)
                            ? "invalid"
                            : "valid"
                        }
                        value={form.financingValue}
                        onChange={(e) => {
                          setForm({ ...form, financingValue: e });
                        }}
                        // onBlur={handleSubmitForm}
                        placeholder="R$"
                        maxLength={22}
                        prefix="R$ "
                        mask="decimal"
                        size="medium"
                        label="Valor Financiamento"
                        width="100%"
                      />
                    </BaSeGridItem>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <BaSeInput
                        color="default"
                        inputMode="decimal"
                        typeInput="tel"
                        inputStatus={
                          validateCurrency(form.guaranteesValue)
                            ? "invalid"
                            : "valid"
                        }
                        value={form.guaranteesValue}
                        onChange={(e) => {
                          setForm({ ...form, guaranteesValue: e });
                        }}
                        // onBlur={handleSubmitForm}
                        placeholder="R$"
                        maxLength={22}
                        prefix="R$ "
                        mask="decimal"
                        size="medium"
                        label="Valor garantias exigidas pelo banco"
                        width="100%"
                      />
                    </BaSeGridItem>
                  </BaSeGrid>
                </div>
                <div className="fampe-range">
                  <FampeInputRange
                    value={limitStatus}
                    setValue={setLimitStatus}
                    label="Qual a porcentagem de garantia FAMPE você gostaria de calcular?"
                  />
                </div>
                <div
                  style={{
                    paddingBottom: "16px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <BaSeButton
                    onClick={handleSubmitForm}
                    value="Realizar Cálculo"
                    buttonType="button"
                    color="#005EB8"
                    isBold
                    rightIcon="refresh-alt"
                    size="small"
                    type="secondary"
                    isDisabled={form.financingValue === '0,00' || !form.guaranteesValue === '0,00'}
                  ></BaSeButton>
                </div>
                <div>
                  {limitStatus == 80 && (
                    <TipBlock
                      image={GreenStatus}
                      borderColor="linear-gradient(to top, #84F4BC, #E4F998)"
                    >
                      <BaSeHeading6>
                        <span
                          style={{
                            gap: "10px",
                            padding: "8px",
                            display: "flex",
                            textAlign: "left",
                            flexDirection: "column",
                          }}
                        >
                          <strong>
                            O limite padrão de garantias do FAMPE é de 80%.{" "}
                          </strong>
                          Você tem grandes chances de conseguir o aval com esse
                          valor.
                        </span>
                      </BaSeHeading6>
                    </TipBlock>
                  )}
                  {limitStatus > 80 && (
                    <TipBlock
                      image={RedStatus}
                      borderColor="linear-gradient(to top, #F4455A, #FFABAB)"
                    >
                      <BaSeHeading6>
                        <span
                          style={{
                            gap: "10px",
                            display: "flex",
                            textAlign: "left",
                            flexDirection: "column",
                          }}
                        >
                          <strong>
                            O limite padrão de garantias do FAMPE é de 80%.
                          </strong>
                          <span>
                            Situações excepcionais podem contemplar até 100%.
                            Verifique o seu enquadramento{" "}
                            <a
                              target="_blank"
                              href="https://sebrae.com.br/sites/PortalSebrae/fampe"
                              rel="noreferrer"
                            >
                              aqui
                            </a>
                            .
                          </span>
                        </span>
                      </BaSeHeading6>
                    </TipBlock>
                  )}
                  {limitStatus < 80 && (
                    <TipBlock
                      image={YellowStatus}
                      borderColor="linear-gradient(to top, #FFB380, #FFED69)"
                    >
                      <BaSeHeading6>
                        <span
                          style={{
                            gap: "10px",
                            display: "flex",
                            textAlign: "left",
                            flexDirection: "column",
                          }}
                        >
                          <strong>
                            O limite padrão de garantias do FAMPE é de 80%.{" "}
                          </strong>
                          Tem certeza de que deseja um valor menor? Verifique se
                          essa opção atende às suas necessidades.
                        </span>
                      </BaSeHeading6>
                    </TipBlock>
                  )}
                </div>
                <div className="group-input gi-space inputs-blue border-none mb-0">
                  <BaSeGrid>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <div
                        className={
                          "input-error-message " +
                          (form.fampe &&
                          (validateCurrency(form.fampe) ||
                            formatFloat(form.fampe) > getCeiling())
                            ? "invalid"
                            : "")
                        }
                      >
                        <BaSeInput
                          key={fampeGuarantee}
                          color="default"
                          id={
                            limitStatus == 80
                              ? "greenStatus"
                              : limitStatus > 80
                                ? "redStatus"
                                : "yellowStatus"
                          }
                          inputMode="tel"
                          typeInput="tel"
                          value={formatCurrency(
                            Math.min(fampeGuarantee, getCeiling())
                          )}
                          placeholder="R$"
                          maxLength={22}
                          prefix="R$ "
                          mask="decimal"
                          size="medium"
                          label="Garantia Fampe"
                          width="100%"
                          isReadOnly={true}
                          showHelpButton
                          helpButtonProps={{
                            direction: "top",
                            alertSize: 288,
                            iconProps: "#005eb8",
                            // {
                            // color:
                            //   validateCurrency(fampeGuarantee) ||
                            //   formatFloat(fampeGuarantee) > getCeiling()
                            //     ? "#BF303C"
                            //     : "#005eb8",
                            // size: 16,
                            // }
                            title: "FAMPE",
                            message: [
                              "O FAMPE reduz a necessidade de garantias próprias exigidas pela Instituição Financeira em até 80%.",
                              "\n\n• MEI: Teto = R$ 100.000,00",
                              "\n• ME: Teto = R$ 400.000,00",
                              "\n• EPP: Teto = R$ 700.000,00",
                            ],
                            type: "popover",
                          }}
                        />
                        {
                          formatFloat(fampeGuarantee) > getCeiling() && (
                            <span className="error-message" style={{ display: "block" }}>
                              O limite de R$ {formatCurrency(getCeiling())} por
                              operação para o porte selecionado foi atingido. {formatFloat(fampeGuarantee)}
                            </span>
                          )
                        }

                      </div>
                    </BaSeGridItem>
                    <BaSeGridItem
                      desktop={{
                        size: 6,
                        startAt: undefined,
                      }}
                    >
                      <BaSeInput
                        key={form.cng}
                        color="default"
                        inputMode="tel"
                        typeInput="tel"
                        value={formatCurrency(necessaryComplement)}
                        placeholder="R$"
                        maxLength={22}
                        prefix="R$ "
                        mask="decimal"
                        size="medium"
                        label="Complemento necessário de garantias"
                        width="100%"
                        isReadOnly={true}
                      />
                    </BaSeGridItem>
                  </BaSeGrid>
                </div>

                <div className="planning__footer">
                  <BaSeButton
                    type="secondary"
                    buttonType="button"
                    onClick={() => backStep()}
                    color="#005eb8"
                    size="medium"
                    value="Anterior"
                    width="87px"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </BaSeGridItem>
        <BaSeGridItem
          desktop={{
            size: 3,
            startAt: undefined,
          }}
          desktopLarge={{
            size: 4,
            startAt: undefined,
          }}
        >
          <div className="box-fampe">
            <p>
              Saiba mais sobre o FAMPE{" "}
              <a
                target="_blank"
                href="https://sebrae.com.br/sites/PortalSebrae/fampe"
                rel="noreferrer"
              >
                aqui
              </a>
            </p>
            <figure>
              <img src={logoFampe} alt="FAMPE" loading="lazy" />
            </figure>
          </div>
        </BaSeGridItem>
      </BaSeGrid>
    </div>
  );
};

export default Guarantees;
